<template>
    <div>

        <el-row class="column-name" justify="start">
            <span>基本信息</span>
        </el-row>

        <el-form label-position="right" :model="assessmentVersionDetail" label-width="120px">

            <el-row>
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="版本号">
                        <el-input v-model="assessmentVersionDetail.version" size="small" class="width70"
                                  disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="状态">
                        <el-select class="width70" v-model="assessmentVersionDetail.status" clearable filterable
                                   placeholder="请选择状态" size="small" :disabled="disableFlag">
                            <el-option
                                    v-for="item in assessmentVersionStatus"
                                    :key="item.value"
                                    :label="item.desc"
                                    :value="item.value"
                                    :disabled="item.disabled">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="编制人员">
                        <el-input v-model="assessmentVersionDetail.changeby" size="small" class="width70"
                                  disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="编制时间">
                        <el-input v-model="assessmentVersionDetail.changedate" size="small" class="width70"
                                  disabled></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="assessmentVersionDetail.reviseby">
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="修订人员">
                        <el-input v-model="assessmentVersionDetail.reviseby" size="small" class="width70"
                                  disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="修订时间">
                        <el-input v-model="assessmentVersionDetail.revisedate" size="small" class="width70"
                                  disabled></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="assessmentVersionDetail.reviseby">
                <el-col :xs="24" :sm="24" :md="24" :lg="24">
                    <el-form-item label="修订备注">
                        <el-input v-model="assessmentVersionDetail.remark" type="textarea" class="width80"
                                  :disabled="disableFlag" maxlength="800"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="assessmentVersionDetail.reviseby">
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="原版本">
                        <el-input v-model="assessmentVersionDetail.fromversion" size="small" class="width70"
                                  disabled></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

        </el-form>

        <el-row v-if="assessmentVersionDetail.id" ref="pf_tab">
            <el-tabs v-model="activeTab" @tab-click="handle_tab_click">
                <el-tab-pane label="分项评分配置" name="fxpf_tab">
                    <assessment-conf-table ref="actRef" :assessmentVersionDetail="assessmentVersionDetail" :offsetTop="offsetTop" @afterSavedConfRecord="afterSavedConfRecord"></assessment-conf-table>
                </el-tab-pane>
                <el-tab-pane label="加、减分项配置" name="jjfx_tab">
                    <addsub-config-table @afterSavedAddSubConfRecord="afterSavedAddSubConfRecord"></addsub-config-table>
                </el-tab-pane>
            </el-tabs>
        </el-row>
    </div>
</template>

<script>

    import {createNamespacedHelpers} from "vuex";
    import assessmentVersionStatus from "../mixins/assessmentVersionStatus";
    import assessmentConfTable from "../config/assessmentConfTable";
    import addsubConfigTable from "../addsubconf/addsubConfigTable";

    const assessmentVersionNSHelper = createNamespacedHelpers("assessment/assessmentVersion");

    export default {

        name: "assessmentVersionDetail",

        mixins: [assessmentVersionStatus],

        components: {
            assessmentConfTable,
            addsubConfigTable,
        },

        data() {
            return {
                activeTab: 'fxpf_tab',

                disableFlag: true,

                changeStatusWarring: true,

                offsetTop: 0,
            }
        },

        computed: {
            ...assessmentVersionNSHelper.mapGetters(['assessmentVersionDetail']),

            status() {
                return this.assessmentVersionDetail.status;
            },
        },

        methods: {

            ...assessmentVersionNSHelper.mapActions(['getAssessmentVersionDetail']),

            handle_tab_click() {

            },

            afterSavedAddSubConfRecord() {
                this.afterSavedRelRecord();
            },

            afterSavedConfRecord() {
                this.afterSavedRelRecord();
            },

            afterSavedRelRecord() {
                this.getAssessmentVersionDetail(this.assessmentVersionDetail.id);
            }

        },

        watch: {

            status: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    if (newVal != null && oldVal != null) {
                        //草稿或不活动状态变更为活动状态时，需要提示
                        if ((newVal == 'ACTIVE') && (oldVal == 'DRAFT' || oldVal == 'INACTIVE')) {
                            this.changeStatusWarring = false;
                        } else {
                            this.changeStatusWarring = true;
                        }
                    }
                }
            },

        },

        updated() {
            this.offsetTop = this.$refs.pf_tab.$el.offsetTop;
        },


    }
</script>

<style scoped>

</style>